import { PageId } from 'constants/pages'

export const enum PageIdWoofzK9 {
  DOG_AGE_K9 = PageId.DOG_AGE_K9,
  DOG_SEX_K9 = PageId.DOG_SEX_K9,
  DOG_BREED_K9 = PageId.DOG_BREED_K9,
  DOG_BREED_ID_K9 = PageId.DOG_BREED_ID_K9,
  URGE_K9 = PageId.URGE_K9,
  CHALLENGES_K9 = PageId.CHALLENGES_K9,
  URGE_1_K9 = PageId.URGE_1_K9,
  LEASH_PULLING_K9 = PageId.LEASH_PULLING_K9,
  URGE_LEASH_K9 = PageId.URGE_LEASH_K9,
  DURING_WALK_K9 = PageId.DURING_WALK_K9,
  URGE_NOT_ALONE_K9 = PageId.URGE_NOT_ALONE_K9,
  AGRESSIVE_BEHAVIOR_K9 = PageId.AGRESSIVE_BEHAVIOR_K9,
  TRIGGERS_K9 = PageId.TRIGGERS_K9,
  URGE_2_K9 = PageId.URGE_2_K9,
  BEHAVIOR_ISSUES_K9 = PageId.BEHAVIOR_ISSUES_K9,
  DOG_ACT_K9 = PageId.DOG_ACT_K9,
  DOG_OFF_AT_HOME_K9 = PageId.DOG_OFF_AT_HOME_K9,
  REWARDS_K9 = PageId.REWARDS_K9,
  IGNORE_COMMANDS_K9 = PageId.IGNORE_COMMANDS_K9,
  COMMANDS_61_K9 = PageId.COMMANDS_61_K9,
  COMMANDS_62_K9 = PageId.COMMANDS_62_K9,
  COMMANDS_63_K9 = PageId.COMMANDS_63_K9,
  URGE_3_K9 = PageId.URGE_3_K9,
  PREPARE_SCREEN_K9 = PageId.PREPARE_SCREEN_K9,
  DOG_PROFILE_K9 = PageId.DOG_PROFILE_K9,
  URGE_REVIEWED_K9 = PageId.URGE_REVIEWED_K9,
  SOCIAL_SCREEN_K9 = PageId.SOCIAL_SCREEN_K9,
  PREPARE_FLOW_K9 = PageId.PREPARE_FLOW_K9,
  EMAIL_K9 = PageId.EMAIL_K9,
  NEWSLETTER_URGE_K9 = PageId.NEWSLETTER_URGE_K9,
  DISCIPLINE_SCREEN_K9 = PageId.DISCIPLINE_SCREEN_K9,
  SCRATCH_SCREEN_K9 = PageId.SCRATCH_SCREEN_K9,
  WELCOME_TO_WOOFZ_K9 = PageId.WELCOME_TO_WOOFZ_K9,
  SUBSCRIPTIONS_K9 = PageId.SUBSCRIPTIONS_K9,
  CHAT_UPSELL_K9 = PageId.CHAT_UPSELL_K9,
  UPSELL_K9 = PageId.UPSELL_K9,
  UPSELL_FEEDING_GUIDE_K9 = PageId.UPSELL_FEEDING_GUIDE_K9,
  UPSELL_EMOTIONAL_SUPPORT_K9 = PageId.UPSELL_EMOTIONAL_SUPPORT_K9,
  DOWNLOAD_K9 = PageId.DOWNLOAD_K9,
  ACCOUNT_K9 = PageId.ACCOUNT_K9,
}
